import React from 'react';
import { usePresence } from '../hooks/usePresence';

interface CollaboratorsListProps {
    batchId: string;
}

export const CollaboratorsList: React.FC<CollaboratorsListProps> = ({ batchId }) => {
    const { presence } = usePresence(batchId);

    if (presence.length <= 1) return null; // Only show if others are present

    return (
        <div className="flex items-center gap-2 px-4 py-2 bg-indigo-50 dark:bg-indigo-900/10 border-b border-indigo-100 dark:border-indigo-900/20 animate-in fade-in slide-in-from-top-1 duration-300">
            <span className="material-icons-round text-indigo-500 text-sm animate-pulse">groups</span>
            <div className="flex -space-x-2">
                {presence.map((p, i) => (
                    <div
                        key={p.id + i}
                        className="w-6 h-6 rounded-full bg-indigo-500 border-2 border-white dark:border-surface-dark flex items-center justify-center text-[8px] font-bold text-white shadow-sm"
                        title={p.full_name}
                    >
                        {p.full_name?.charAt(0).toUpperCase() || '?'}
                    </div>
                ))}
            </div>
            <span className="text-[10px] font-bold text-indigo-600 dark:text-indigo-400">
                {presence.length} 位同事正在作业
            </span>
        </div>
    );
};
